import { Directive, Input, ElementRef, HostListener } from "@angular/core";

@Directive({
  selector: "[pingParallax]"
})
export class ParallaxDirective {
  // @Input("pingParallax") parallaxRatio: number = -0.3;
  // initialTop: number = 0;

  // constructor(private eleRef: ElementRef) {
  //   if (this?.eleRef?.nativeElement?.getBoundingClientRect) {
  //     this.initialTop = this.eleRef.nativeElement.getBoundingClientRect().top;
  //   }
  // }

  // @HostListener("window:scroll", ["$event"])
  // onWindowScroll(event) {
  //   if (this?.eleRef?.nativeElement && window?.scroll) {
  //     if (this.eleRef.nativeElement.offsetHeight > window?.scrollY && window?.innerWidth > 768) {
  //       this.eleRef.nativeElement.style.transform = `translate3d(0,${this
  //         .initialTop -
  //         window.scrollY * this.parallaxRatio}px,0)`;
  //     }
  //   }
  // }
}
